import { Observable } from 'rxjs';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { CardViewModel } from 'src/models/card-view-model';
import {
  ActiveAlertRecord,
  ActiveAlertViewModelBase,
} from 'src/store/generated/active-alert-record.generated';
import { timeElapsed } from 'src/util/helpers/date-helper';
import { PersonViewModel } from './person-view-model';

export enum RequestStatusCd {
  CallReceived = 0,
  AssignmentDelayed = 5,
  Offering = 10,
  Offered = 20,
  Assigned = 30,
  Cancelled = 3000,
}

export class ActiveAlertViewModel extends ActiveAlertViewModelBase {
  public readonly timeAcknowledgedString: string | undefined;
  public readonly personAcknowledged$: Observable<PersonViewModel | undefined>;

  constructor(
    activeAlert: ActiveAlertRecord,
    private _model: ViewModelService,
    private readonly card?: CardViewModel,
  ) {
    super(activeAlert);

    this.personAcknowledged$ = _model.getPersonById(this.acknowledgedById);
    this.timeAcknowledgedString =
      this.dateAcknowledged == null ? undefined : timeElapsed(this.dateAcknowledged);
  }
}
